import React from "react";
import { useDispatch } from 'react-redux';

import { Breadcrumbs, Button } from "@material-ui/core";
import { Search, PersonAdd, FindInPage } from "@material-ui/icons";

import { MENU_MESA_ENTRADA, MENU_TIPO_EXPEDIENTE, MESA_ENTRADA_COMPROBANTES_ESTADOS, TIPO_EFECTORES } from "../../../utils/constants";
import { cleanComprobantesMesaEntrada, cleanProformasMesaEntrada, setEstadosComprobante, setRecepcionMenu, setTipoEfectorMenu } from "../../../actions/mesaEntrada/mesaEntradaActions";
import { cleanPresupuestosMesaEntrada } from "../../../actions/mesaEntrada/presupuestosMesaEntrada";

const style = {
  root: {
    flexGrow: 1,
  },
};

export const MesaEntradaBreadcrumb = ({ setComprobantes, setActiveBreadcrumb, activeBreadcrumb, setContrato }) => {
  const dispatch = useDispatch();

  const resetMenu = () => {
    setComprobantes([]);
    dispatch(cleanComprobantesMesaEntrada());
    dispatch(cleanProformasMesaEntrada());
    dispatch(cleanPresupuestosMesaEntrada());
    dispatch(setRecepcionMenu(MENU_TIPO_EXPEDIENTE.DESELECCIONAR));
    dispatch(setTipoEfectorMenu(TIPO_EFECTORES.CONTRATO_PRESTADORES));
    dispatch(setEstadosComprobante(MESA_ENTRADA_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO?.toString()));
    setContrato(null);
  }

  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      <Button
        color={
          activeBreadcrumb === MENU_MESA_ENTRADA.RECEPCION_COMPROBANTES
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          resetMenu();
          setActiveBreadcrumb(MENU_MESA_ENTRADA.RECEPCION_COMPROBANTES);
        }}
      >
        <PersonAdd className={style.icon} />
        Recepción Comprobantes
      </Button>
      <Button
        color={
          activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          resetMenu();
          setActiveBreadcrumb(MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES);
        }}
      >
        <Search className={style.icon} />
        Gestión Comprobantes Prestadores / Proveedores
      </Button>
      <Button
        color={
          activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          resetMenu();
          setActiveBreadcrumb(MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO);
        }}
      >
        <Search className={style.icon} />
        Gestión Comprobantes Documento
      </Button>
      <Button
        color={
          activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_OSPE_DIRECTO
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          resetMenu();
          setActiveBreadcrumb(MENU_MESA_ENTRADA.GESTION_COMPROBANTES_OSPE_DIRECTO);
        }}
      >
        <Search className={style.icon} />
        Gestión Ospedyc Directo
      </Button>
      <Button
        color={
          activeBreadcrumb === MENU_MESA_ENTRADA.BUSCADOR_EXPEDIENTES
            ? "default"
            : "inherit"
        }
        onClick={(e) => {
          resetMenu();
          setActiveBreadcrumb(MENU_MESA_ENTRADA.BUSCADOR_EXPEDIENTES);
        }}
      >
        <FindInPage className={style.icon} />
        Buscador de Expedientes
      </Button>
    </Breadcrumbs>
  );
};
